import "./Category.css";

import { Breadcrumb, message, Table, type TableColumnsType, Tag } from "antd";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { SectionHeader, TableMenuDropdown } from "../../_lib/_components";
import { type CategoryType, useAppSelector } from "../../_lib/_store";
import {
  deleteCategory,
  getCategories,
} from "../../_lib/_store/services/categoryService";

export const CategoryPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, categories } = useAppSelector((state) => state.category);
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getCategories(messageApi);
  };

  const columns: TableColumnsType<CategoryType> = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Tags",
      dataIndex: "tags",
      key: "tags",
      render: (tags: string[]) =>
        tags?.map((tag, index) => <Tag key={index}>{tag}</Tag>),
    },
    {
      title: "Package Id",
      dataIndex: "package",
      key: "package",
      render: (_, obj) => <p>{obj?.package?.name}</p>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const handleMenuClick = (key: string, obj: CategoryType) => {
    switch (key) {
      case "show":
        navigate(`/category/show`, { state: { category: obj } });
        break;
      case "edit":
        navigate(`/category/edit`, { state: { category: obj } });
        break;
      case "delete":
        deleteCategory(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="category">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: "Category",
            },
          ]}
        />
        <SectionHeader dataLength={categories.length} createRoute="category" />
        <Table
          sticky
          dataSource={categories}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1000 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
